import { useMutation } from '@tanstack/react-query';

import { MutationConfig, mutationFn } from '@/lib/react-query';

interface SignDocumentParams {
  documentId: number;
}

interface UseSignDocumentOptions {
  options?: MutationConfig<typeof signDocumentFn>;
  defaultParams?: SignDocumentParams;
}

const signDocumentFn = (params: SignDocumentParams) =>
  mutationFn<SignDocumentParams, string>(`/self-service/customers/contracts/${params.documentId}/sign`);

export const useSignDocument = ({ options, defaultParams }: UseSignDocumentOptions = {}) => {
  return useMutation({
    mutationFn: (params: SignDocumentParams) => {
      if (defaultParams) {
        return signDocumentFn({ ...defaultParams, ...params });
      }
      return signDocumentFn(params);
    },
    ...options,
  });
};
